import React, {useEffect} from 'react';
import {Box} from '@mui/material';
import {Outlet} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {resetPaginationState} from '../../../hoc/pagination/paginationSlice';

const RequestAndResponsesTab = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(resetPaginationState());
        };
    }, []);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                minHeight: '100%',
                paddingTop: 2,
            }}
        >
            <Outlet/>
        </Box>
    );
};

export default RequestAndResponsesTab;